import React from 'react'
import ButtonComponent from '../../../../components/Buttons/ButtonComponent';

import Grid from '@mui/material/Grid';
const ButtonRegUserAccessList = ({ dataRegUserAccess = [], reloadData, handleEdit }) => {
    return (
        <div className="row">
            <div className='col-12'>
                <Grid container item spacing={1} direction="row" style={{ 'maxWidth': '100vw', margin: '0px', columnGap: '8px', rowGap: '10px' }}>
                    {ButtonComponent.ReloadButton(reloadData)}
                    {dataRegUserAccess.map((elm) => (
                        <>
                            {elm.accessCode === 'UPD' && ButtonComponent.EditButton(handleEdit, 'User Access')}
                        </>
                    ))}
                </Grid>
            </div>
        </div>
    )
}

export default ButtonRegUserAccessList